import useSWR from "swr";
import axios from "axios";

function useUser({ shouldFetch = true, userId }) {
  return useSWR(shouldFetch ? [
    `${process.env.REACT_APP_API_URL}/users/${userId}`
  ] : null, async ([url]) => {
    const params = new URLSearchParams();

    const { data: user } = await axios.get(`${url}?${params.toString()}`);

    return { user };
  });
}

export default useUser;
